import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { APIContext } from 'context/APIContext'
import { ModalContext } from '../ModalContext'

import BrandColorButton from 'components/Buttons/BrandColorButton'

const programPresetOptions = [
    {
        'key': 'kinesis-run',
        'label': 'Kinesis Run Program',
    },
    {
        'key': 'kinesis-tri',
        'label': 'Kinesis Tri Program',
    },
    {
        'key': 'kinesis-cycle',
        'label': 'Kinesis Cycle Program',
    },
    {
        'key': 'kinesis-swim',
        'label': 'Kinesis Swim Program',
    },
    {
        'key': 'bch-fall-2026',
        'label': 'BCH Fall 2026 Program',
    }
]

const defaultProgramPreset = programPresetOptions[0].key
const GetProgramPresetName = (programPresetKey) => programPresetOptions.find((option) => option.key === programPresetKey)?.label ?? ''

export default function CreateProgramModal() {

    const navigate = useNavigate()

    const { CreateProgram } = useContext(APIContext)
    const { HideModal } = useContext(ModalContext)

    const [programPreset, setProgramPreset] = useState(defaultProgramPreset)
    const [programName, setProgramName] = useState(GetProgramPresetName(defaultProgramPreset))
    const [programDescription, setProgramDescription] = useState('')
    const [createProgramLoading, setCreateProgramLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const HandleFormChange = (key, value) => {

        setErrorMessage('')

        switch (key) {
            case 'programPreset':
                setProgramPreset(value)
                setProgramName(GetProgramPresetName(value))
                break
            case 'programName':
                setProgramName(value)
                break
            case 'programDescription':
                setProgramDescription(value)
                break
            default:
                setErrorMessage('Invalid form change')
                break
        }
    }

    const OnCreateProgramButton = async () => {
        if (programName.trim() === '') {
            setErrorMessage('Program name is required')
            return
        }

        setCreateProgramLoading(true)

        const newProgramId = await CreateProgram(programName, programDescription, programPreset)

        if (newProgramId === null) {
            setErrorMessage('Failed to create program. Please try again.')
            setCreateProgramLoading(false)
            return
        }

        HideModal()
        
        navigate(`/program/${newProgramId}/playground`)

        setCreateProgramLoading(false)
    }

    return (
        <>
            <div className="text-center text-lg font-semibold leading-6 text-gray-900">
                Create Program
            </div>

            <div className="space-y-4 text-left">
                <div className="space-y-2">
                    <p className="w-full text-left">Preset</p>

                    <select
                        className="w-full p-2 border border-gray-300 rounded-md bg-white cursor-pointer"
                        value={programPreset}
                        onChange={(e) => HandleFormChange('programPreset', e.target.value)}
                    >
                        <option value="none">None</option>

                        {programPresetOptions.map((programPresetOption) => (
                            <option key={programPresetOption.key} value={programPresetOption.key}>
                                {programPresetOption.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="space-y-2">
                    <p className="w-full text-left">Name*</p>
                    <input
                        type="text"
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter name here"
                        value={programName}
                        onChange={(e) => HandleFormChange('programName', e.target.value)}
                    />
                </div>

                <div className="space-y-2">
                    <p className="w-full text-left">Description</p>
                    <textarea
                        className="w-full h-28 p-2 border border-gray-300 rounded-md"
                        placeholder="Enter description here"
                        value={programDescription}
                        onChange={(e) => HandleFormChange('programDescription', e.target.value)}
                    />
                </div>

                <BrandColorButton
                    text="Create Program"
                    action={OnCreateProgramButton}
                    isLoading={createProgramLoading}
                />

                {errorMessage &&
                    <p className="text-center text-red-500 font-semibold text-sm">
                        {errorMessage}
                    </p>
                }
            </div>
        </>
    )
}
